<template>
      <el-dialog customClass="dialog_detail_style" :title="title" :visible.sync="ishow" @close="onCancel" v-dialogDrag>
        <v-content class="contnet_box" :formData="iformData" ref="content"></v-content>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onCancel">取 消</el-button>
            <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import vContent from "./TenantMngFormPanel.vue";
export default {
    components:{
        vContent
    },
    props:{
       formData:{
           Type:Object,
           default(){
               return {
                     countryCode: "CN" //国家地区默认中国
               }
           }
       },
       show:{
          Type:Boolean,
          default(){
              return false
          }
       },
       title:{
          Type:String,
          default(){
              return '租户管理-新增'
          }
       }
    },
    watch:{
       show(newVal,oldVal){
           this.ishow=newVal;
       },
       formData(newVal){
           this.iformData=newVal;
       }
    },
    data(){
       return {
           iformData:this.formData||{countryCode: "CN"},
           ishow:this.show
       }
    },
    methods:{
        onSubmit(){
          let vm=this;
          vm.$refs.content.validataForm(function(conentData){
               vm.$emit("onSubmitTenant",vm.iformData);
          })          
        },
        onCancel(){
            let vm=this;
            vm.iformData={};
            vm.ishow=false;
            vm.$emit("onCloseTenantWindow", vm.ishow);
        }
    }
}
</script>